module.exports = __webpack_public_path__ + "images/Pak Evan.8f3bfc78.png";